import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import CustomerLogosSection from '../components/CustomerLogosSection';
import ApproachSection from '../components/ApproachSection';
import ServicesSection from '../components/ServicesSection';
import Contactpage from './ContactPage';
import SEO from '../components/SEO';

const HomePage = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "monkStack",
    "description": "monkStack is a Pune-based AI and engineering studio that builds production SaaS, computer vision, and manufacturing ERP.",
    "url": "https://monkstack.com",
    "logo": "https://monkstack.com/img/logo_landing.png",
    "sameAs": [
      "https://in.linkedin.com/company/monkstack"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "telephone": "+91-8600-35-8700",
      "email": "info@monkstack.com",
      "availableLanguage": "English"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "OFFICE NO 311 - NYATI ETERNITY, UNDRI",
      "addressLocality": "Pune",
      "postalCode": "411060",
      "addressCountry": "IN"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "monkStack",
    "url": "https://monkstack.com"
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://monkstack.com"
      }
    ]
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "AI & Engineering Solutions",
    "provider": {
      "@type": "Organization",
      "name": "monkStack",
      "url": "https://monkstack.com"
    },
    "areaServed": "Worldwide",
    "description": "AI & Engineering Solutions including AI & Intelligent Automation, Document Intelligence & OCR, Computer Vision Solutions, SaaS & Enterprise App Development, Cloud Migration, and IT Consulting.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "monkStack Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI & Intelligent Automation",
            "description": "Build intelligent copilots that assist in decision-making, automate tasks, and improve productivity across workflows."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Document Intelligence & OCR",
            "description": "Extract, process, and analyze data from PDFs, forms, and invoices using advanced OCR and document AI models."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Computer Vision Solutions",
            "description": "Enable image and video intelligence with custom AI models for detection, classification, and real-time analytics."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SaaS & Enterprise App Development",
            "description": "Design and build scalable SaaS platforms and enterprise-grade apps with modern architectures and integrations."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Cloud Migration",
            "description": "Move infrastructure and applications to the cloud securely while optimizing for cost, scalability, and performance."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "IT Consulting & CTO as a Service",
            "description": "Provide expert guidance on technology strategy, architecture, and execution to align IT with business goals."
          }
        }
      ]
    }
  };

  return (
    <div className="App">
      <SEO
        title="monkStack - AI & Engineering Solutions"
        description="monkStack is a Pune-based AI and engineering studio that builds production SaaS, computer vision, and manufacturing ERP for operators who need software that ships."
        url="https://monkstack.com"
        structuredData={[organizationSchema, websiteSchema, breadcrumbSchema, serviceSchema]}
      />
      <Navbar />
      <main className="main-content" id="home">
        <HeroSection />
      </main>
      
      {/* <CollaboratorSection /> */}
      {/* <IndustriesSection /> */}
      {/* <HomePage/> */}

      <ServicesSection />
      <ApproachSection />
      {/* <TestimonialsSection /> */}
      
      {/* <LocationSection /> */}
      <CustomerLogosSection />
      <div className="homepage-contact" id="contact">
        <Contactpage/>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default HomePage;

